import { _pejerProvider, defaultPejerState, usePejerBase } from 'pejer/src/stores/pejerData'
import { PejerMerchant } from './PejerMerchant'
import { config } from './config'

const pejer = new PejerMerchant({
  ...defaultPejerState,
  data: {},
})

export const pejerProvider = () => _pejerProvider(pejer as any, config)

export const usePejer = () => {
  const pejer = usePejerBase() as PejerMerchant
  if (!pejer.config) throw new Error('Pejer config not set')

  return pejer
}

export { config }
